// import state from './saved-items-state';
// import mutations from './saved-items-mutations';
import actions from './notifications-actions';
// import getters from './saved-items-getters';

export default {
  namespaced: true,
  // state,
  // mutations,
  actions,
  // getters,
};
